(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[698],{

/***/ 9361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 6447:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers",
      function () {
        return __webpack_require__(7987);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImageGliph; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);


function ImageGliph(param) {
    var src = param.src;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "glyph-image-container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            layout: "raw",
            width: "200",
            height: "200",
            src: "/assets/animated-glyphs/".concat(src, ".gif")
        })
    });
}


/***/ }),

/***/ 7987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Careers; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var components_MetaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8992);
/* harmony import */ var components_Elements_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4721);
/* harmony import */ var components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7603);
/* harmony import */ var components_Elements_ButtonTicker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5935);
/* harmony import */ var strapi_api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1014);
/* harmony import */ var components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4318);









var __N_SSG = true;
function Careers(props) {
    var generateDelay = function() {
        return Math.floor(Math.random() * 6) + 1;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_MetaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: props.content.meta_info && props.content.meta_info.meta_title ? props.content.meta_info.meta_title : "CAREERS",
                description: props.content.meta_info && props.content.meta_info.meta_description ? props.content.meta_info.meta_description : "Careers - ZANAD | An Independent Animation Production Studio",
                image: props.content.meta_info && props.content.meta_info.og_image ? strapi_api__WEBPACK_IMPORTED_MODULE_8__/* ["default"].getNextImage */ .Z.getNextImage(props.content.meta_info.og_image, "large") : "/public/og-image.jpg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "offscreen-title",
                        children: "Careers"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Elements_Container__WEBPACK_IMPORTED_MODULE_3__/* .ContainerWithOffset */ .jZ, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "mt-8 mb-6 uppercase fluid-type",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "flex flex-row justify-start",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "optical-align letter-i",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 3.5,
                                                    children: "If "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 1,
                                                    children: "you "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 6,
                                                    children: "like"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 2.5,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                        src: "MARGIN_MAGIC"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 5,
                                                    children: "to"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "flex flex-row justify-end",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 2,
                                                    children: "move "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 5,
                                                    children: "it "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 1.5,
                                                    children: "move "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 4.5,
                                                    children: "it"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "flex flex-row justify-start",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "optical-align letter-z",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 3.5,
                                                    children: "Zanad's "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 2.5,
                                                    children: "the"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 4.5,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                        src: "MARGIN_WIZARD"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 1,
                                                    children: "place "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 3,
                                                    children: "to "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 5.5,
                                                    children: "go."
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-24 leading-tight text-20 768:text-30 1024:text-40 1280:text-48 indent-10 768:indent-20 1024:indent-36 1280:indent-48 content-with-glyphs",
                                children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(props.content.content)
                            }),
                            props.content.job.length ? props.content.job.map(function(job, i) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "grid grid-cols-1 gap-4 mb-24 640:gap-12 768:gap-10 1024:gap-16 991:grid-cols-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                            className: "uppercase fluid-type",
                                            children: [
                                                job.level && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: generateDelay(),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "block",
                                                        children: job.level
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: generateDelay(),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "block",
                                                        children: job.position
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "max-w-screen-md mb-8 leading-tight text-16 768:text-18 1280:text-22",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: job.description
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "grid gap-4 mb-4 640:gap-10 1024:gap-6 640:grid-cols-2",
                                                    children: [
                                                        job.responsibilities && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "mb-4 leading-tight text-content text-16 768:text-18 1280:text-22 640:mb-0 content-with-glyphs",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "RESPONSIBILITIES"
                                                                }),
                                                                (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(job.responsibilities)
                                                            ]
                                                        }),
                                                        job.requirements && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "leading-tight text-content text-16 768:text-18 1280:text-22",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "REQUIREMENTS"
                                                                }),
                                                                (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(job.requirements)
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ButtonTicker__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    title: "Apply now",
                                                    url: job.email_apply ? "mailto:" + job.application : job.application,
                                                    external: true
                                                })
                                            ]
                                        })
                                    ]
                                }, i);
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "no-careers",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "mt-8 mb-6 uppercase fluid-type",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "flex flex-row justify-start",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: "optical-align letter-i",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                            num: 3.5,
                                                            children: "one "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                            num: 1,
                                                            children: "more "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                            num: 6,
                                                            children: "person "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "inline-flex 768:-ml-4",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                num: 2.5,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                                    src: "MARGIN_SKULL"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                            num: 5,
                                                            children: "and "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                            num: 3,
                                                            children: "we’ll "
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "flex flex-row justify-end text-right",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: "optical-align letter-z",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                            num: 3.5,
                                                            children: "all "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                            num: 2.5,
                                                            children: "get "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                            num: 1,
                                                            children: "socially "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                            num: 3,
                                                            children: "anxious"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                            num: 2.5,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                                src: "MARGIN_GLOBE"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "mb-24 leading-tight text-20 768:text-30 1024:text-40 1280:text-48 indent-10 768:indent-20 1024:indent-36 1280:indent-48 content-with-glyphs",
                                        children: [
                                            "Even if we’re not hiring right now for the position you’re looking for, we’d still love to see your work. Email us at",
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "transition-colors border-b-2 border-black hover:border-white",
                                                href: "mailto:work@zanad.tv",
                                                children: "work@zanad.tv"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [608,774,888,179], function() { return __webpack_exec__(6447); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);